import React from 'react';
import { Button, Checkbox, Dropdown, Icon } from 'antd';
import common from '../../assets/common.js';
import download from '../../images/download.svg';
import screen from '../../images/screen.svg';
import refresh from '../../images/refresh.svg';
import './index.css'

const CheckboxGroup = Checkbox.Group;

class Action extends React.Component {
  constructor(){
    super();
    this.state = {

    }
  }
  componentWillMount(){

  }
  changeColumns = (columnsShow) => {
    const obj = this.props.obj;
    const table = obj.state.table;
    const { columnsList } = table;
    columnsShow.push("action");
    const columns = [];
    common.eachObj(columnsList, function(index, dataItem){
      const dataIndex = dataItem.dataIndex;
      if(columnsShow.indexOf(dataIndex) > -1){
        columns.push(dataItem);
      }
    });
    table.columns = columns;
    table.columnsShow = columnsShow;
    table.scroll = common.getScroll(table);
    obj.setState({ table });
  }
  refreshList = () => {
    const obj = this.props.obj;
    const pagination = obj.state.table.pagination;
    if(!obj.state.table.loading) obj.getList(pagination.current);
  }
  downList = () => {
    const url = this.props.url;
    this.props.downlist();
    // window.open(url)
  }
  render(){
    const obj = this.props.obj;
    const { table } = obj.state;
    // console.log(table);
    const { columnsShow, columnsList, mustList } = table;
    const menu = (
      <CheckboxGroup value={ columnsShow } onChange={ this.changeColumns.bind(this) } className="table-columns-check">
        {
          columnsList && columnsList.map((d, i) => {
            const key = d.dataIndex;
            if(mustList.indexOf(key) > -1){
              return ""
            } else {
              return <Checkbox className="menuAction-one" key={ "columns" + d.dataIndex } value={d.dataIndex} >{ d.title }</Checkbox>
            }
          })
        }
      </CheckboxGroup>
    );
    const url = this.props.url;
    return(
      <div className="table-menu-action">
        <div  className="table-menu-action-btn">
          { url && <Dropdown
            overlay={ <div className="table-menu-actoun-div"><Button  className="table-menu-action-down" onClick={ this.downList }>导出记录</Button></div> }
            placement="bottomRight"
            trigger={['hover']}
            getPopupContainer={() => document.getElementsByClassName('table-menu-action')[0] }
            >
              <Button className="table-menu-action-one"><Icon type="cloud-download" style={{fontSize:'18px',color:'#40a9ff',fontWeight: 'bold'}}/></Button>
            </Dropdown>
          }
          <Dropdown
            className="columnsCreen-drop"
            overlay={ menu }
            placement="bottomRight"
            trigger={['hover']}
            getPopupContainer={() => document.getElementsByClassName('table-menu-action')[0] }
          >
            <Button className="table-menu-action-one"><img src={ screen } alt=""/></Button>
          </Dropdown>
          <Button className="table-menu-action-one"><img src={ refresh } alt="" onClick={ this.refreshList }/></Button>
        </div>
      </div>
    )
  }
}
export default Action;



// WEBPACK FOOTER //
// ./src/modest/menuaction/index.js